export const getPeriodBySport = (id) => {
  switch (id) {
    case 3:
    case 4: // Basquetbol
      return 5;
    case 16: // Voleibol
    case 17:
    case 54: // Voleibol 2
    case 55:
      return 3;
    case 6:
    case 7: // Futsal
      return 4;
    case 5: // Fútbol
    case 42:
    case 52: // Fútbol 2
    case 53:
      return 4;
    case 40:
    case 51: // Handball
      return 4;
    case 44: 
    case 45: // Voleibol Playa
      return 3;
    case 56: // Rugby
    case 57:
      return 3;
    default:
      return 4;
  }
};
